import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  contained?: boolean;
}
const SIZES = {
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-3xl',
  xl: 'max-w-5xl'
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  contained = false
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-763" data-mp="6ay1rwji3j2h">
      {open && <div className={`${contained ? 'absolute' : 'fixed'} inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4`} data-id="element-764" data-mp="6bzo4x5yvrzi">
          <motion.div className="absolute inset-0 bg-navy-950/50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} onClick={onClose} data-id="element-765" data-mp="38hvxxrgr4q19" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} className={`relative w-full ${contained ? '' : SIZES[size]} bg-white rounded-t-2xl sm:rounded-2xl shadow-pop flex flex-col max-h-[92%] sm:max-h-[88vh]`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: EASE
      }} data-id="element-766" data-mp="3cjz9sh7c1wn2">
            <div className="flex items-center justify-between gap-3 border-b border-line px-5 py-3.5 no-print" data-id="element-767" data-mp="263n8w8d4m0ns">
              <h2 className="text-base font-bold text-ink" data-id="element-768" data-mp="215dehzz87438">{title}</h2>
              <button onClick={onClose} className="btn-ghost btn btn-sm h-8 w-8 px-0" aria-label="বন্ধ করুন" data-id="element-769" data-mp="212zhhlkzjht1">
                <XIcon className="h-4 w-4" data-id="element-770" data-mp="a0ijey9ktuge" />
              </button>
            </div>
            <div className="overflow-y-auto scroll-thin px-5 py-4 flex-1" data-id="element-771" data-mp="9yfl7qy9sv0l">{children}</div>
            {footer && <div className="border-t border-line px-5 py-3 flex flex-wrap justify-end gap-2 no-print" data-id="element-772" data-mp="etuwqc8t2etu">{footer}</div>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}